import { Injectable, Injector } from '@angular/core';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { IGetInstanceService } from '@fi-app/utilities/fi-model/get-instance-service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ChecklistReportLastActivePeriodStatusHeaderComponent } from './checklist-report-last-active-period-status-header/checklist-report-last-active-period-status-header.component';
import { ChecklistReportLastActivePeriodStatusGridColumnComponent } from './checklist-report-last-active-period-status-grid-column/checklist-report-last-active-period-status-grid-column.component';
import { ChecklistReportLastActivePeriodStatusColumnComponent } from './checklist-report-last-active-period-status-column/checklist-report-last-active-period-status-column.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class ChecklistReportListDataService implements IGetInstanceService {
    constructor(private injector: Injector) {}

    getInstance(isLocalSort?: boolean) {
        return new ChecklistReportListData(this.injector, isLocalSort);
    }
}

export class ChecklistReportListData extends ListData<ChecklistModel> {
    constructor(injector: Injector, isLocalSort?: boolean) {
        super(injector, isLocalSort);

        this.ObjectType = ObjectTypes.CheckListReport;

        this.ShowCheckBox = false;

        this.ShowDelete = false;

        this.ShowFavoriteIcon = false;

        this.IconClass = 'fi-icon-checklist';

        this.Sort.Reverse = true;

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder ccmListViewHiddenCell',
                    true,
                    ChecklistReportLastActivePeriodStatusGridColumnComponent,
                    {
                        Sref: () => {
                            return FiStateNames.Checklist.Report.View;
                        },
                        SrefParams: (data) => {
                            return { Id: data.Id };
                        },
                    },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: () => {
                        return FiStateNames.Checklist.Report.View;
                    },
                    SrefParams: (data) => {
                        return { Id: data.Id };
                    },
                    mobileSubText: (data) => {
                        return injector.get(FiFormatDateService).formatDate(data.StartDateTime, 'date-time');
                    },
                }),
            ),
        );

        this.addChangedOnHeader();

        this.addCreatedByHeader();

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('checklist.latest_status'),
                'LastActivePeriodStatus',
                new ItemsListHeaderProperties(
                    'last-active-period-status CcmList-Column-ShowAlways',
                    false,
                    ChecklistReportLastActivePeriodStatusColumnComponent,
                    {
                        headLabelType: ChecklistReportLastActivePeriodStatusHeaderComponent,
                    },
                ),
            ),
        );
    }
}
